import { useState } from 'react';

function useToggleState(initialState = false) {
    const [value, setValue] = useState(initialState);
    const enable = () => {
        setValue(true);
    };
    const disable = () => {
        setValue(false);
    };
    const toggleValue = () => {
        setValue((prevState) => !prevState);
    };
    return {
        value,
        enable,
        disable,
        toggleValue,
    };
}

export { useToggleState as default, useToggleState };
//# sourceMappingURL=useToggleState.js.map
